import { render } from "./Faculties.vue?vue&type=template&id=278f0dc8&scoped=true"
import script from "./Faculties.vue?vue&type=script&lang=js"
export * from "./Faculties.vue?vue&type=script&lang=js"

import "./Faculties.vue?vue&type=style&index=0&id=278f0dc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-278f0dc8"]])

export default __exports__